module.exports = __webpack_public_path__ + "assets/img/information.5eafb594.svg";